var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.canActivity
        ? [
            _c("CellAttribute", {
              attrs: {
                state: _vm.state,
                board: _vm.board,
                attributes: _vm.systemAttributes
              },
              on: {
                "open-system-attributes": function($event) {
                  return _vm.$emit("open-system-attributes")
                }
              }
            }),
            _vm._v(" "),
            _c("ActivityAttribute", {
              attrs: {
                state: _vm.state,
                board: _vm.board,
                attributes: _vm.systemAttributes
              },
              on: {
                "open-system-attributes": function($event) {
                  return _vm.$emit("open-system-attributes")
                }
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.definitions, function(def) {
        return _c("Attribute", {
          key: def.id,
          attrs: { state: _vm.state, card: _vm.card, definition: def }
        })
      }),
      _vm._v(" "),
      _c("SurveyResultAttribute", {
        attrs: { state: _vm.state, board: _vm.board, card: _vm.card }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }